module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "el"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-291f9ae6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HighChart.vue
// module id = 492
// module chunks = 2